import getFieldRequirement from './fieldRequirementResolver'
import { toFieldRequirementResolverContext } from './types'
import { createGetFieldRequirementWithParentLookup } from '../../resolverFactory'
import { FieldRequirement } from '../../../../../models/fieldRules'
import { GetDeclarationFormFieldRequirementContext } from '../../types'

export const baseGetFieldRequirement = (
  path: string,
  ctx: GetDeclarationFormFieldRequirementContext,
): FieldRequirement => {
  const requirement = getFieldRequirement(path, toFieldRequirementResolverContext(path, ctx))
  if (!requirement) return 'optional'

  return requirement
}

export const getEnsTransitOperationFieldRequirement = createGetFieldRequirementWithParentLookup(baseGetFieldRequirement)
